import { Component, input } from '@angular/core';
import { MaterialModule } from '../../common/material/material.module';
import type { UnbestaetigteUuidList } from '../../domain/model/unbestaetigte-uuid-snapshot.model';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'redispatch-dashboard-unbestaetigte-uuids',
    imports: [
        MaterialModule,
        DatePipe,
    ],
    templateUrl: './dashboard-unbestaetigte-uuids.component.html',
    styleUrl: './dashboard-unbestaetigte-uuids.component.scss',
})
export class DashboardUnbestaetigteUuidsComponent {
    unbestaetigteUuids = input<UnbestaetigteUuidList>([]);

    displayedColumns: string[] = [
        'netzbetreiberName',
        'stadtwerkeId',
        'countUnbestaetigteUuids',
        'lastBestaetigtDate',
    ];

    // eslint-disable-next-line max-len
    tooltipText = 'Durch Anpassungen im Leitsystem kann es zu Änderung der UUIDs kommen, welche für den RD-Prozess der nVNBs relevant sind. Um einen funktionierenden RD-Prozess zu garantieren, ist der nVNB verpflichtet die Änderungen zu bestätigen.';
}
